import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

interface AppIcon {
  alt: string;
  src: string;
  label: string;
  downloadCount: string;
  invertColors?: boolean;
}

@Component({
  selector: 'app-app-icon-section',
  imports: [],
  templateUrl: './app-icon-section.component.html',
  styleUrl: './app-icon-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppIconSectionComponent {
  readonly count = input<number>(6);

  private readonly allIcons: AppIcon[] = [
    {
      alt: 'BusinessCards',
      src: 'assets/images/icons/snapaddy-businesscards.png',
      label: 'BusinessCards',
      downloadCount: '1M+',
    },
    {
      alt: 'Body Tutor',
      src: 'assets/images/icons/body-tutor.png',
      label: 'Body Tutor',
      downloadCount: '20K+',
    },
    {
      alt: 'BTC-ECHO',
      src: 'assets/images/icons/btc-echo.webp',
      label: 'BTC-ECHO',
      downloadCount: '100K+',
    },
    {
      alt: 'Clovis',
      src: 'assets/images/icons/clovis.png',
      label: 'Clovis',
      downloadCount: '10K+',
    },
    {
      alt: 'CSFloat',
      src: 'assets/images/icons/csfloat.png',
      label: 'CSFloat',
      downloadCount: '1M+',
    },
    {
      alt: 'DHBW VS',
      src: 'assets/images/icons/dhbw.webp',
      label: 'DHBW VS',
      downloadCount: '10K+',
    },
    {
      alt: 'HOKITA',
      src: 'assets/images/icons/hokita.webp',
      label: 'HOKITA',
      downloadCount: '50K+',
    },
    {
      alt: 'Logistiko',
      src: 'assets/images/icons/logistiko.png',
      label: 'Logistiko',
      downloadCount: '10K+',
    },
    {
      alt: 'myGiGroup',
      src: 'assets/images/icons/mygigroup.jpg',
      label: 'myGiGroup',
      downloadCount: '200K+',
    },
    {
      alt: 'Pictalk Buddy',
      src: 'assets/images/icons/pictalk.png',
      label: 'Pictalk Buddy',
      downloadCount: '50K+',
    },
    {
      alt: 'Summon Worlds',
      src: 'assets/images/icons/summon-worlds.webp',
      label: 'Summon Worlds',
      downloadCount: '500K+',
    },
    {
      alt: 'UnivLorraine',
      src: 'assets/images/icons/univ-lorraine.webp',
      label: 'UnivLorraine',
      downloadCount: '200K+',
    },
    {
      alt: 'VisitReport',
      src: 'assets/images/icons/snapaddy-visitreport.png',
      label: 'VisitReport',
      downloadCount: '100K+',
    },
    {
      alt: 'Vitruve',
      src: 'assets/images/icons/vitruve.png',
      label: 'Vitruve',
      downloadCount: '50K+',
    },
    {
      alt: 'VRStar',
      src: 'assets/images/icons/vrstar.png',
      label: 'VRStar',
      downloadCount: '10K+',
    },
    {
      alt: 'Zenda',
      src: 'assets/images/icons/zenda.png',
      label: 'Zenda',
      downloadCount: '500K+',
    },
  ];

  readonly icons = computed(() => {
    const icons = [...this.allIcons].sort(() => Math.random() - 0.5);
    return icons.slice(0, this.count());
  });
}
